import React from 'react';
import { URL } from '../variables';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import { languages, languageOptions, getSelectedLanguage, setSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faculdade: null,
            loading: false,
            loading_enter: false,
            msgErro: '',
            credencial: '',
            password: '',
            redirect: false,
            path: '',
            showPassword: false,
            theme: localStorage.getItem('avaliador_theme') || 'light',
            selectedLanguage: getSelectedLanguage()
        }
    }

    login(event) {
        event.preventDefault();
        let faculdade_id = null;
        if (this.state.faculdade != null) faculdade_id = this.state.faculdade.id;
        this.setState({ loading_enter: true, msgErro: '' });
        fetch(`${URL}api/avaliador/auth/login`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ credencial: this.state.credencial, password: this.state.password, faculdade_id })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) erro += errors[i] + (i != errors.length - 1 ? '\n' : '');
                    this.setState({ loading: false, loading_enter: false, msgErro: erro, refresh: false, loadingMore: false });
                }
                else {
                    localStorage.setItem('token', resp.access_token);
                    this.props.login({ token: resp.access_token, user: {} });
                }
            } catch (err) {
                console.log(err);
                this.setState({ loading: false, loading_enter: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false, loading_enter: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
        });
    }

    get_faculdade(slug) {
        fetch(`${URL}api/avaliador/get_faculdade/${slug}`, { method: 'GET', headers: { Accept: 'application/json' } }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) erro += errors[i] + (i != errors.length - 1 ? '\n' : '');
                    this.setState({ loading: false, msgErro: erro });
                }
                else {
                    if (resp.faculdade != null) this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    else this.setState({ redirect: true, path: '/', loading: false });
                }
            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor' });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
        });
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        document.body.classList.toggle('avaliador-dark-theme', this.state.theme == 'dark');
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('avaliador_language_change', this.languageListener);
        this.setState({ loading: true, msgErro: '' });
        this.get_faculdade(params.slug);
    }

    componentWillUnmount() {
        if (this.languageListener) window.removeEventListener('avaliador_language_change', this.languageListener);
    }

    toggleTheme() {
        let theme = this.state.theme == 'dark' ? 'light' : 'dark';
        localStorage.setItem('avaliador_theme', theme);
        document.body.classList.toggle('avaliador-dark-theme', theme == 'dark');
        this.setState({ theme });
    }

    changeLanguage(event) {
        let selectedLanguage = setSelectedLanguage(event.target.value);
        this.setState({ selectedLanguage });
    }

    changeEmail(event) {
        let text = event.target.value;
        let final_num = '';
        if (text.length > 0 && isNaN(text[0])) {
            final_num = text;
            this.setState({ credencial: final_num });
        }
        else if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {
                for (let i = 0; i < text.length; i++) {
                    if (i == 3) final_num += '.' + text[i];
                    else if (i == 6) final_num += '.' + text[i];
                    else if (i == 9) final_num += '-' + text[i];
                    else final_num += text[i] + '';
                }
                this.setState({ credencial: final_num });
            }
        }
        else this.setState({ credencial: final_num });
    }

    changePassword(event) { this.setState({ password: event.target.value }); }

    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        return (
            <div className="avaliador-login-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading && <Loader fullScreen title={t.loading_data} description={t.loading_environment} />}
                {!this.state.loading && <div className="login-screen-v2">
                    <div className="login-form-panel-v2 avaliador-login-panel">
                        <div className="card">
                            <div className="card-body avaliador-login-card-body">
                                {this.state.faculdade != null && <div className="text-center"><a className="logo"><img src={this.state.faculdade.logo} height="80" alt="logo" /></a></div>}
                                {this.state.faculdade == null && <div className="text-center"><a className="logo"><img src={require('../assets/images/logo-ontest.png')} height="82" alt="logo" /></a></div>}
                                <div className="avaliador-login-form">
                                    <span className="avaliador-auth-kicker">{t.login_hero_brand}</span>
                                    <h4 className="font-18 m-b-5">{t.login_welcome}</h4>
                                    <p className="text-muted">{t.login_subtitle}</p>
                                    <form className="form-horizontal m-t-30" onSubmit={this.login.bind(this)}>
                                        <div className="form-group row"><div className="col-12"><label>{t.email} <span>*</span></label><input id="credencial" type="username" className="form-control" name="credencial" placeholder={t.credential_placeholder} value={this.state.credencial} onChange={this.changeEmail.bind(this)} required autoComplete="email" autoFocus /></div></div>
                                        <div className="form-group row"><div className="col-12"><label>{t.password} <span>*</span></label><div className="avaliador-password-field"><input id="password" type={this.state.showPassword ? 'text' : 'password'} value={this.state.password} onChange={this.changePassword.bind(this)} placeholder={t.password_placeholder} className="form-control" name="password" required autoComplete="current-password" /><button type="button" onClick={() => this.setState({ showPassword: !this.state.showPassword })}><i className={this.state.showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'}></i></button></div></div></div>
                                        <div className="form-group row m-t-20"><div className="col-sm-12">{this.state.msgErro != '' && <div className="badge badge-danger avaliador-login-error-badge" role="alert">{this.state.msgErro}</div>}</div>{this.state.loading_enter == false ? <div className="col-sm-12 text-right"><button className="btn btn-primary w-md waves-effect waves-light avaliador-login-submit" type="submit">{t.enter}</button></div> : <div className="col-12"><Loader compact title={t.loading} description={null} /></div>}</div>
                                    </form>
                                </div>
                                <div className="text-center avaliador-login-footer"><p>© {new Date().getFullYear()} OnTest</p><div className="avaliador-preference-controls"><button type="button" className="avaliador-preference-theme-button" onClick={this.toggleTheme.bind(this)} title={this.state.theme == 'dark' ? t.theme_light : t.theme_dark}><i className={this.state.theme == 'dark' ? 'mdi mdi-white-balance-sunny' : 'mdi mdi-weather-night'}></i><span>{this.state.theme == 'dark' ? t.theme_light : t.theme_dark}</span></button><label className="avaliador-preference-select"><span><i className="mdi mdi-web"></i>{t.language_label}</span><select value={this.state.selectedLanguage} onChange={this.changeLanguage.bind(this)} aria-label={t.language_label}>{languageOptions.map((item) => <option key={item.value} value={item.value}>{item.value}</option>)}</select></label></div></div>
                            </div>
                        </div>
                    </div>
                    <div className="login-hero-v2" style={{ backgroundImage: `url(${require('../assets/images/avaliador-login-bg.png')})` }}><div className="login-hero-overlay-v2"></div><div className="login-hero-copy-v2"><span>{t.login_hero_brand}</span><h1>{t.login_hero_title}</h1><p>{t.login_hero_text}</p></div></div>
                </div>}
            </div>
        );
    }
}

const mapsStateToProps = (state) => ({});
export default connect(mapsStateToProps, { login })(Login);
